import Calendar from './Calendar';

export default function CalendarioPage() {
  return <Calendar />;
}






